import DetailedCookiesItem from 'cookies/components/DetailedCookiesItem'
import { COOKIE_TYPE_ANALYTICS } from 'cookies/constants'

const DetailedCookies = ({ cookieDetails, setCookieDetails, translate: t }) => {
    const onChange = name => {
        setCookieDetails(prevState => ({ ...prevState, [name]: !prevState[name] }))
    }

    return (
        <div className="mt-4">
            <DetailedCookiesItem title={<T>cookie.modal.details.necessary</T>}>
                <T>cookie.modal.details.necessary.content</T>
            </DetailedCookiesItem>
            <DetailedCookiesItem
                enabled={cookieDetails.analytics}
                toggleEnable={() => onChange(COOKIE_TYPE_ANALYTICS)}
                title={t('cookie.modal.details.analytics')}>
                <T>cookie.modal.details.analytics.content</T>
            </DetailedCookiesItem>
        </div>
    )
}

export default withTranslate(DetailedCookies)
